import goodShiftLogo from "@/../public/goodshift/logo.png"

import { ImageProps } from "next/image"
import { twMerge } from "tailwind-merge"
import Image from "./Image"

type LogoProps = Omit<ImageProps, "src"> & {
  src?: string
  showBorder?: boolean
}

const LogoImage: React.FunctionComponent<LogoProps> = ({ showBorder, alt, className, src, ...imageProps }) => {
  const safeSrc = src || goodShiftLogo.src
  return (
    <Image
      src={safeSrc}
      alt={alt}
      className={twMerge(showBorder ? "border border-gray-40 rounded-2xl" : "", " object-contain", className)}
      {...imageProps}></Image>
  )
}

export default LogoImage
